// const { default: Swiper } = require("swiper");

import Swiper from 'swiper';
import 'swiper/css';

// Sliders
var Sliders = function () {

    var Load = function () {
        const progressCircle = document.querySelector(".autoplay-progress svg");
        const progressContent = document.querySelector(".autoplay-progress span");
        var swiper = new Swiper(".slider-swipper", {
            spaceBetween: 0,
            centeredSlides: true,
            effect: "fade",
            keyboard: {
                enabled: true,
                onlyInViewport: false,
            },
            autoplay: {
                delay: 30000,
                disableOnInteraction: false
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            scrollbar: {
                el: ".swiper-scrollbar",
            },
            on: {
                // autoplayTimeLeft(s, time, progress) {
                //     progressCircle.style.setProperty("--progress", 1 - progress);
                //     progressContent.textContent = `${Math.ceil(time / 1000)}s`;
                // },
                slideChange: function (el) {
                    $('.swiper-slide').each(function () {
                        var youtubePlayer = $(this).find('iframe').get(0);
                        if (youtubePlayer) {
                            youtubePlayer.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                        }
                    });
                },
            }
        });
    }

    return {
        init: function () {
            Load();
        },
    };



}();

// References
var References = function () {

    var Load = function () {
        var swiper = new Swiper(".references-swipper", {
            slidesPerView: 8,
            spaceBetween: 10,
            loop: true,
            lazy: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
        });
    }

    return {
        init: function () {
            Load();
        },
    };

}();


// Articles
var Articles = function () {

    var Load = function () {
        var swiper = new Swiper(".articles-swipper", {
            slidesPerView: 4,
            spaceBetween: 10,
            // freeMode: true,
            // loop: true,
            lazy: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
        });
    }

    return {
        init: function () {
            Load();
        },
    };

}();

// Products
var Products = function () {

    var Load = function () {
        document.querySelectorAll('.products-swipper').forEach(function (element) {
            var swiper = new Swiper(element, {
                slidesPerView: 5,
                spaceBetween: 15,
                loop: true,
                lazy: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
            });
        })

    }

    return {
        init: function () {
            Load();
        },
    };

}();


$(function () {
    Sliders.init();
    References.init();
    Articles.init();
    Products.init();
});